import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { MessageService } from 'primeng/components/common/messageservice';

import { BaseService } from '../base/util/base.service';
import { assinarContrato, buscarContratosPrestador, servicoIp } from '../base/util/url-util';
import { Contrato } from '../base/vo/contrato';


@Injectable()
export class ModalDocumentoService extends BaseService {

  control = false;

  constructor(public http: HttpClient, public messageService: MessageService) {
    super(http, messageService);
  }

  getDocuments(prestador: number): Observable<Contrato[]> {
    return this.http.get<Contrato[]>(
      buscarContratosPrestador(prestador)
    );
  }

  getIP(): Observable<any> {
    return this.http.get(servicoIp());
  }

  getPosition(): Observable<any> {
    return Observable.create((observer) => {
      window.navigator.geolocation.getCurrentPosition(
        (position) => {
          observer.next(position);
          observer.complete();
        },
        (error) => observer.next(error)
      );
    });
  }

  documentAssignment(
    id: number,
    prestador: number,
    assinaturaRequest: any
  ): Observable<any> {
    return this.http.post(assinarContrato(id, prestador), assinaturaRequest);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-documentos/modal-documentos.service.ts